import { createAction } from '@reduxjs/toolkit';
import { withPayloadType } from 'utils';

export const getOrganizationStart = createAction(
  'GET_ORGANIZATION::START',
  withPayloadType<{ id: string }>(),
);
